.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font: var(--t-body-strong);
  color: var(--ink);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.control {
  position: relative;
  display: flex;
  align-items: center;
  width: 176px;
  flex: none;
}

.input {
  width: 100%;
  height: var(--control-height);
  padding: 0 var(--space-7) 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  font-variant-numeric: tabular-nums;
}

.input[data-focused] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

.input[data-invalid] {
  border-color: var(--status-error-fg);
}

.input[data-disabled] {
  background: var(--wash);
  color: var(--pencil);
}

/* Out of range: the value itself turns bold (DESIGN.md §7). */
.field[data-abnormal] .input {
  font: var(--t-body-strong);
  font-variant-numeric: tabular-nums;
}

/* Critical: clinical danger, the one use of the danger colour. */
.field[data-critical] .input {
  border-color: var(--danger);
  color: var(--danger);
}

.unit {
  position: absolute;
  right: var(--space-3);
  color: var(--graphite);
  font: var(--t-small);
  pointer-events: none;
}

.flag {
  font: var(--t-body-strong);
  color: var(--ink);
}

.flag[data-flag='no_range'] {
  font: var(--t-small);
  color: var(--graphite);
}

.flag[data-flag='critical_low'],
.flag[data-flag='critical_high'] {
  color: var(--danger);
}

.provisional {
  font: var(--t-small);
  color: var(--graphite);
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

.error {
  color: var(--status-error-fg);
  font: var(--t-small);
  font-weight: 600;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
